export function getVideoDimensions(file: File): Promise<{ width: number; height: number }> {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const video = document.createElement('video');

    video.preload = 'metadata';
    video.src = url;

    video.onloadedmetadata = () => {
      // Video metadata is loaded
      resolve({ width: video.videoWidth, height: video.videoHeight });
      URL.revokeObjectURL(url); // Clean up
    };

    video.onerror = () => {
      reject(new Error('Failed to load video metadata.'));
      URL.revokeObjectURL(url);
    };
  });
}
